import {Type} from 'main.core';
import * as BX from "main";

const apiUrl = 'compuproject:helper.api.userapi.';

export class UserApi {
    constructor(options = {name: 'UserApi'})
    {
        this.name = options.name;
    }

    updateUser(data) {
        return BX.ajax.runAction(`${apiUrl}updateUser`,{
            data: data
        });
    }

    changePassword(data) {
        return BX.ajax.runAction(`${apiUrl}changePassword`,{
            data: data
        });
    }

    loginUser(data = {login:null,password:null}) {
        return BX.ajax.runAction(`${apiUrl}loginUser`,{
            data: data
        });
    }

    loginPhoneUser(data = {login:null,code:null}) {
        return BX.ajax.runAction(`${apiUrl}LoginPhoneUser`,{
            data:data
        });
    }

    sendPass(data = {phone:null}){
        return BX.ajax.runAction(`${apiUrl}sendPass`,{
            data:data
        });
    }

    logoutUser() {
        return BX.ajax.runAction(`${apiUrl}logoutUser`);
    }

    registerUser(data = {
        email:null,
        firstName:null,
        lastName:null,
        password:null,
        confirmPassword:null,
    }) {
        return BX.ajax.runAction(`${apiUrl}registerUser`,{
            data: data
        });
    }

    sendPassword(data = {
        email:null,
    }) {
        return BX.ajax.runAction(`${apiUrl}sendPassword`,{
            data: data
        });
    }

    setName(name)
    {
        if (Type.isString(name))
        {
            this.name = name;
        }
    }

    getName()
    {
        return this.name;
    }
}
